import { useEffect, useState } from 'react';
import { getSiteVisits } from '../services/siteVisitsService';
import { SITE_VISIT_PERIODS, summarizeSiteVisits } from '../lib/siteVisits';

// Card "Visitas no site" do Painel Administrativo — mesmo visual e altura do
// DashboardStatCard: título numa linha e o seletor Dia / Semana / Mês logo
// abaixo, no espaço da 2ª linha de título dos outros cards (mesma altura
// mínima de cabeçalho), pra o número ficar alinhado com eles.
export const SiteVisitsCard = ({ className = '' }) => {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  const [period, setPeriod] = useState('day');

  useEffect(() => {
    let cancelled = false;
    getSiteVisits()
      .then((result) => { if (!cancelled) setData(result); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, []);

  const summary = data ? summarizeSiteVisits(data, period) : null;

  // Sem dados do período anterior: a linha de comparação some.
  let comparison = null;
  if (failed) {
    comparison = 'Indisponível no momento';
  } else if (summary && summary.changePct !== null) {
    const { changePct } = summary;
    const color = changePct > 0 ? 'text-green-600 dark:text-green-400'
      : changePct < 0 ? 'text-red-600 dark:text-red-400' : '';
    comparison = (
      <>
        <span className={`font-semibold ${color}`}>{changePct > 0 ? '+' : ''}{changePct}%</span> {summary.comparison}
      </>
    );
  }

  // Duas linhas curtas ao lado do número (cabem na altura dele), pra o card
  // ter só a linha de comparação embaixo, como o subtítulo dos outros.
  const unique = summary && (period === 'day'
    ? [`${summary.uniqueVisitors.toLocaleString('pt-BR')} visitantes`, 'únicos']
    : [`${summary.uniqueVisitors.toLocaleString('pt-BR')} únicos`, 'soma dos dias']);

  return (
    <div className={`h-full bg-card border border-border rounded-xl p-3 sm:p-4 2xl:p-3 flex flex-col gap-2 ${className}`}>
      <div className="flex flex-col items-start gap-0.5 min-h-10">
        <p className="max-w-full truncate text-xs sm:text-sm font-medium text-muted-foreground leading-tight">Visitas no site</p>
        <div className="flex rounded-md bg-muted p-0.5" role="group" aria-label="Período">
          {Object.entries(SITE_VISIT_PERIODS).map(([key, { label }]) => (
            <button
              key={key}
              type="button"
              onClick={() => setPeriod(key)}
              aria-pressed={period === key}
              className={`rounded px-1 py-0.5 text-[10px] leading-none font-medium transition-colors ${
                period === key ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <p className="text-2xl font-bold tracking-tight" data-testid="admin-stat-site-visits">
            {summary ? summary.visits.toLocaleString('pt-BR') : '—'}
          </p>
          {unique && (
            <p className="min-w-0 text-[11px] leading-tight text-muted-foreground" title={unique.join(' ')}>
              <span className="block truncate">{unique[0]}</span>
              <span className="block truncate">{unique[1]}</span>
            </p>
          )}
        </div>
        {comparison && <p className="text-xs text-muted-foreground mt-0.5 truncate">{comparison}</p>}
      </div>
    </div>
  );
};
